import { useVnmSubscriptionStatus } from 'hooks/use-vnm-subscription-status.hook';
import { useProductStatus, ProductType } from 'hooks/use-product-status.hook';
import { ClientError } from 'utils/errors/client-errors';
import { isWaitlist } from 'domain/vnm';

export const AVAILABLE = 'available';
export const PENDING = 'pending';
export const ENROLLED = 'enrolled';
export const INELIGIBLE = 'ineligible';
export const CANCELED = 'canceled';
export const UNAVAILABLE = 'unavailable';
export const WAITLIST = 'waitlist';

interface Props {
  planId?: number;
}
export const useSolarState = ({ planId }: Props) => {
  const vnm = useProductStatus(ProductType.Vnm, planId);
  const subscriptionStatus = useVnmSubscriptionStatus({ planId });

  const error = vnm.error || subscriptionStatus.error || !vnm.data;
  const loading = vnm.loading || subscriptionStatus.loading;

  let state;
  // TODO: remove && vnm.data when we upgrade to TS 4.4
  if (!error && !loading && vnm.data) {
    const status = subscriptionStatus.data?.status || '';
    if (vnm.data.isAvailable) state = AVAILABLE;
    else if (vnm.data.isPending) state = PENDING;
    else if (vnm.data.isCanceled) state = CANCELED;
    else if (vnm.data.isIneligible) state = INELIGIBLE;
    else if (vnm.data.isActive && isWaitlist(status)) state = WAITLIST;
    else if (vnm.data.isActive) state = ENROLLED;
    else if (vnm.data.isUnavailable) state = UNAVAILABLE;
    else {
      throw new ClientError(
        `state ${vnm.data.status} is currently unsupported.`
      );
    }
  }
  let data;
  if (state) {
    data = { state };
  }

  return {
    data,
    error,
    loading,
    vnmRefetch: () => vnm.refetch(),
    subscriptionStatusRefetch: () => subscriptionStatus.refetch(),
  };
};

export const useSolarStateMock = {
  data: { state: UNAVAILABLE },
  error: undefined,
  loading: false,
  vnmRefetch: () => null,
  subscriptionStatusRefetch: () => null,
};
